import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LanguageProvider } from "./i18n";
import { ThemeProvider } from "./ui/theme";
import { FontScaleProvider } from "./ui/fontScale";
import { UiFontProvider } from "./ui/uiFont";
import { SourcesPrefProvider } from "./ui/sourcesPref";
import { TaskViewPrefProvider } from "./ui/taskViewPref";
import { MailUnreadProvider } from "./ui/mailUnread";
import { ToastProvider } from "./ui/toast";
import { ModalProvider } from "./ui/modal";
// Self-hosted Fonts (DSGVO — kein Google-Fonts-Egress).
import "@fontsource-variable/inter";
// Wählbare UI-Schriften (Einstellungen → Anzeige → Schriftart, ui/uiFont.tsx).
// Alle statisch importiert und trotzdem sparsam: jede @fontsource-Datei liefert
// pro Subset ein eigenes @font-face mit `unicode-range`, der Browser lädt
// deshalb nur die woff2 der TATSÄCHLICH gesetzten Familie (verifiziert im Netz-
// Log des Walks). Ein dynamischer Import je Wahl wäre ein Ladezustand mehr für
// nichts.
// Bewusst der Paket-Einstieg statt eines Subset-Einstiegs: @fontsource-variable
// 5.x liefert gar keine `latin.css`/`latin-ext.css`, sondern EINE index.css mit
// allen Subsets. Damit ist latin-ext (U+1E00-1E9F) mit drin — und nur dort
// wohnt das Versal-ẞ (U+1E9E). Ohne latin-ext fiele genau dieser Buchstabe auf
// eine fremde Schrift zurück.
import "@fontsource-variable/open-sans";
import "@fontsource-variable/ibm-plex-sans";
import "@fontsource-variable/source-sans-3";
import "@fontsource-variable/atkinson-hyperlegible-next";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/700.css";
import "@fontsource/cormorant-garamond/400-italic.css";
// Lexend — Headings + Grosszahlen im Email-Automatisierungs-Tab (scoped via
// .ea-tab; Body bleibt Inter). Selbst gebundelt, kein CDN.
import "@fontsource/lexend/500.css";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* Die Sprache steht ganz aussen: sie betrifft jede der Hüllen darunter
        (Toasts und Modals tragen eigene Beschriftungen). */}
    <LanguageProvider>
      <ThemeProvider>
        <FontScaleProvider>
          <UiFontProvider>
            <SourcesPrefProvider>
              <TaskViewPrefProvider>
                <MailUnreadProvider>
                  <ToastProvider>
                    <ModalProvider>
                      <BrowserRouter>
                        <App />
                      </BrowserRouter>
                    </ModalProvider>
                  </ToastProvider>
                </MailUnreadProvider>
              </TaskViewPrefProvider>
            </SourcesPrefProvider>
          </UiFontProvider>
        </FontScaleProvider>
      </ThemeProvider>
    </LanguageProvider>
  </React.StrictMode>
);

// Service-Worker für Web-Push (P1.7). Feature-getestet + non-blocking: der SW
// registriert nur in einem Secure-Context (HTTPS oder localhost) — auf einem
// HTTP-non-localhost-Origin schlägt register() still fehl (kein Crash, Push
// bleibt schlicht inaktiv). Prod (atlas.bitop.de = HTTPS) registriert normal.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* Kein Secure-Context / SW nicht verfügbar → Push degradiert still. */
    });
  });
}
